const shouldBeSelected = (name, menu, index) => {
  if (menu.length > index + 1) {
    const selectedName = menu[index + 1].payload.name;

    return name === selectedName;
  }

  return false;
};

export default shouldBeSelected;
